import { getToken } from './user-service';

const BASE_URL = '/api/v1/cpu/sla-reports/queue-status';

export const fetchQueueStatus = async (requestId) => {
  if (!requestId) return { status: 'unknown', position: null, queueLength: 0, inFlight: 0 };

  const token = await getToken();
  const url = `${BASE_URL}?requestId=${encodeURIComponent(requestId)}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Firebase-UID': token },
  });

  if (!response.ok) return { status: 'unknown', position: null, queueLength: 0, inFlight: 0 };
  return response.json();
};

/**
 * Generate a unique request ID for queue tracking.
 */
export const generateRequestId = () => {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
};

/**
 * Wraps a fetch call with a timeout. Returns a promise that rejects with
 * a descriptive error if the timeout expires before the fetch completes.
 */
export const fetchWithTimeout = (fetchFn, timeoutMs = 180000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Report timed out. The server was busy — wait a moment and try again.'));
    }, timeoutMs);

    fetchFn()
      .then((result) => {
        clearTimeout(timer);
        resolve(result);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(err);
      });
  });
};
